import { FormattedMessage, useIntl } from 'react-intl';

import FountainAiIcon from '@/assets/icons/fountain-ai.svg';
import TrendingDownIcon from '@/assets/icons/trending-down.svg';
import { Select } from '@/components/ui/select';

export type SortBy = 'list_price.asc' | undefined;

export function Sort({
  sortBy,
  setSortBy,
}: {
  sortBy: SortBy;
  setSortBy: (sortBy: SortBy) => void;
}) {
  const intl = useIntl();

  const sortOptions: { label: React.ReactNode; value: SortBy }[] = [
    {
      label: (
        <div className="flex items-center gap-2">
          <img src={FountainAiIcon} alt="" />
          <FormattedMessage
            defaultMessage="Our top picks"
            description="Option to sort channels by our top picks"
          />
        </div>
      ),
      value: undefined, // This is the default so we don't need to pass it to the API
    },
    {
      label: (
        <div className="flex items-center gap-2">
          <img src={TrendingDownIcon} alt="" />
          <FormattedMessage
            defaultMessage="Price low to high"
            description="Option to sort channels by price low to high"
          />
        </div>
      ),
      value: 'list_price.asc',
    },
  ];

  const handleApply = (selected: SortBy[]) => {
    setSortBy(selected[0]);
  };

  return (
    <Select
      id="sort"
      options={sortOptions}
      selectedValues={sortBy ? [sortBy] : []}
      prefixText={intl.formatMessage({
        defaultMessage: 'Sort by:',
        description: 'Prefix text for the sort dropdown',
      })}
      onApply={handleApply}
      className="w-[240px] rounded-lg"
      isMultiSelect={false}
    />
  );
}
